class ModalToggle extends HTMLElement {
  constructor() {
    super();
    this.modalBtns = this.querySelectorAll('.modal-btn');
    this.modalWraps = this.querySelectorAll('.modal-wrap');
    this.imageElement = this.querySelector('#modal-size-image');
    this.modalSizeModelBtn = this.querySelector('#modal-size-model');
    this.modalSizeBtn = this.querySelector('#modal-size');

    if (this.modalBtns.length && this.modalWraps.length) {
      this.addModalToggleEventListeners();
      this.addModalCloseEventListener();
    }
  }

  addModalToggleEventListeners() {
    this.modalBtns.forEach((btn, index) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleModal(index);
      });
    });

    [this.modalSizeModelBtn, this.modalSizeBtn].forEach((btn) => {
      btn.addEventListener('click', () => this.handleImageChange(btn));
    });
  }

  addModalCloseEventListener() {
    document.addEventListener('click', (e) => {
      const modalClose = e.target.closest('.modal-close');
      if (modalClose || (!e.target.closest('.modal-content') && !e.target.closest('.modal-btn'))) {
        this.closeModal();
      }
    });
  }

  toggleModal(index) {
    document.body.classList.add('modal-open');
    this.modalWraps[index].classList.add('active');
  }

  handleImageChange(button) {
    this.fadeOutImage(() => {
      this.updateImage(button);
      this.toggleActiveClass(button);
    });
  }

  fadeOutImage(callback) {
    if (this.imageElement) {
      this.imageElement.classList.add('fade-out');
      setTimeout(() => {
        callback();
        this.imageElement.classList.remove('fade-out');
      }, 120);
    }
  }

  updateImage(button) {
    const src = button.getAttribute('data-src');
    const alt = button.getAttribute('data-alt');
    if (this.imageElement) {
      this.imageElement.src = src;
      this.imageElement.alt = alt;
    }
  }

  toggleActiveClass(activeBtn) {
    const otherBtn = activeBtn === this.modalSizeModelBtn ? this.modalSizeBtn : this.modalSizeModelBtn;
    activeBtn.classList.add('active');
    otherBtn.classList.remove('active');
  }

  closeModal() {
    this.modalWraps.forEach(content => {
      content.classList.remove('active');
      const video = content.querySelector('video');
      if (video) {
        video.pause();
      }
    });
    document.body.classList.remove('modal-open');
  }
}

customElements.define('modal-toggle', ModalToggle);